"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
var react_i18next_1 = require("react-i18next");
require("./Styles/error-report-id.scss");
var forms_1 = require("../../forms");
exports.ErrorReportID = function (props) {
    var reportId = props.reportId, onGoBackHome = props.onGoBackHome, onClose = props.onClose, visible = props.visible;
    var t = react_i18next_1.useTranslation(['ErrorReporting']).t;
    return (react_1.default.createElement(forms_1.Dialog, { hidden: !visible, onDismiss: function () {
            onClose();
        }, maxWidth: 420, title: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.Icon, { className: 'eta-popup-MailCheck', iconName: 'MailCheck' }),
            t('ErrorReportID.Title'))) },
        react_1.default.createElement("div", { className: 'eta-popup-content', style: { width: 372 } },
            react_1.default.createElement("div", { className: "txt-bold" }, t('ErrorReportID.ReportSent')),
            react_1.default.createElement("div", { className: "txt-light" }, t('ErrorReportID.ReportId')),
            react_1.default.createElement("div", { className: "report-id" },
                react_1.default.createElement("span", null, reportId)),
            react_1.default.createElement("div", { className: "txt-light" }, t('ErrorReportID.Action')),
            react_1.default.createElement("div", { className: "eta-btnsReportId" },
                react_1.default.createElement(react_2.DefaultButton, { className: "default-btn", text: t('Popup.Home'), iconProps: { iconName: 'Home' }, onClick: onGoBackHome })))));
};
//# sourceMappingURL=ErrorReportID.js.map